import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { nafColor } from '@nafcore/theme';
import { borderRadius, spacing } from '@naf/theme';

export const DesktopMenuButton = simbaStyled<typeof Button, Record<string, never>>(Button)(() => ({
  '&&': {
    height: '44px',
    minHeight: 'auto',
    padding: `0 ${spacing.space8}`,
    border: 0,
    borderRadius: borderRadius.L,
    backgroundColor: 'transparent',
    color: nafColor.signature.black,

    '& .naf-ButtonLabel': {
      fontSize: '1rem',
    },

    '&:visited': {
      backgroundColor: 'transparent',
      color: nafColor.signature.black,
    },

    '&:hover': {
      backgroundColor: nafColor.signature.yellow40,
      color: nafColor.signature.black,
      textDecoration: 'none',
    },
  },
}));
